// import { ZAuthRole } from '@/authority/authType';

// import React from 'react';
import { routerListTS } from './types';
const rolesList: routerListTS[] = [];

export default rolesList;
